function appendInOrderByIndex(newElement, container) {
  const newIndex = parseInt(newElement.getAttribute("data-order-index"));
  const items = Array.from(container.children);

  let inserted = false;
  for (let i = 0; i < items.length; i++) {
    const currentIndex = parseInt(items[i].getAttribute("data-order-index"));
    if (newIndex < currentIndex) {
      container.insertBefore(newElement, items[i]);
      inserted = true;
      break;
    }
  }

  if (!inserted) {
    container.appendChild(newElement);
  }
}

const processingIds = [];
const reToggleLoading = () => {
  // Make sure re-rendered pending items keep their loading state
  const quickOrderListWishlistInstances =
    document.querySelectorAll("quick-order-list");
  for (const instance of quickOrderListWishlistInstances) {
    for (const queueItem of BulkAdd.globalState.queue) {
      console.log("re-toggle (pending in queue)");
      instance.toggleLoading(queueItem.id, true);
    }
    for (const processingId of processingIds) {
      console.log("re-toggle (currently processing)");
      instance.toggleLoading(processingId, true);
    }
  }
};

function replaceTagAndAddAttributes(element, newTag, attributes = {}) {
  const newElement = document.createElement(newTag);

  // Copy existing attributes
  Array.from(element.attributes).forEach((attr) => {
    newElement.setAttribute(attr.name, attr.value);
  });

  // Add new attributes
  for (const [key, value] of Object.entries(attributes)) {
    newElement.setAttribute(key, value);
  }

  // Copy the inner content
  newElement.innerHTML = element.innerHTML;

  // Replace the old element with the new one
  return newElement;
}
function handleLoadMoreButton(showLoadMore, loadMoreStartIndex) {
  const loadMoreElement = document.querySelector("#loadMoreWishlist");
  if (loadMoreElement) {
    if (showLoadMore) {
      loadMoreElement.style.display = "inline-flex";
      loadMoreElement.dataset.startIndex = loadMoreStartIndex;
    } else {
      loadMoreElement.style.display = "none";
    }
  }
}

window.showLoading = function () {
  const loadingBox = document.querySelector(".loadingBox");
  const modalOverlay = document.querySelector(".modalOverly");
  if (loadingBox) {
    loadingBox.style.display = "block";
  }
  if (modalOverlay) {
    modalOverlay.style.display = "block";
  }
};
window.hideLoading = function () {
  const loadingBox = document.querySelector(".loadingBox");
  const modalOverlay = document.querySelector(".modalOverly");
  if (loadingBox) {
    loadingBox.style.display = "none";
  }
  if (modalOverlay) {
    modalOverlay.style.display = "none";
  }
};

window.renderWishlistItems = function (
  wishlist = null,
  addDebounce = false,
  limit = 50,
  startIndex = 0,
  clearContent = false
) {
  var wishlistContainer = document.querySelector("#wishlistFetchList");
  var currentItems = wishlistContainer.querySelectorAll(".variant-item");

  if (wishlist == null) {
    var wishlist = defaultWishlist;
  }

  // Clear content once at the beginning, not for each item
  if (clearContent) {
    currentItems.forEach((item) => item.remove());
    // Also clear the container completely to ensure no stale content
    wishlistContainer.innerHTML = '';
  }

  let countItems = Object.entries(wishlist).length;
  let remain = countItems - startIndex;


  if (remain <= 0) {
    startIndex = 0;
    remain = countItems;
  }
  let counter = remain > limit ? limit : remain;
  let loadMoreStartIndex = counter + startIndex;
  let showLoadMore = countItems > loadMoreStartIndex;

  const siteUrl = window.location.protocol + "//" + window.location.hostname;

  let processedCount = 0;
  
  for (const [index, wishlist_item] of Object.entries(wishlist)) {
    const numIndex = parseInt(index);
    
    
    if (numIndex < startIndex) {
      continue;
    }

    // Only process up to the limit
    if (processedCount >= limit) {
      break;
    }

    // console.log(value);
    const handle = wishlist_item.product_handle;
    const variant_id = wishlist_item.variant_id;
    //console.log(handle);
    //console.log(variant_id);

    if (handle && variant_id) {
      processedCount++; // Increment only when we actually process an item
      
      var product_url = `/products/${handle}`;
      var url = `${product_url}?section_id=quick-order-list`;

      fetch(url, {
        method: "GET",
        credentials: "same-origin",
      })
        .then((res) => res.text())
        .then((responseText) => {
          //responseText = responseText.replace("quantity-input","quantity-input-2");
          const html = new DOMParser().parseFromString(
            responseText,
            "text/html"
          );
          // const selectors = ['tr#Variant-50343651737864'];
          const selector = `.quick-order-list-container .card-horizontal`;
          var targetElement = html.querySelector(selector);

          if (targetElement) {
            targetElement.dataset.handle = handle;
            targetElement.dataset.orderIndex = index;
            targetElement.dataset.variantId = variant_id;

            // replace span title with a[href] title
            var variant_item_names = targetElement.querySelectorAll(
              ".variant-item__name"
            );
            variant_item_names.forEach((variant_item_name) => {
              if (variant_item_name) {
                var new_variant_item_name = replaceTagAndAddAttributes(
                  variant_item_name,
                  "a",
                  { href: siteUrl + `/products/${handle}` }
                );
                variant_item_name.replaceWith(new_variant_item_name);
              }
            });

            // Use variant ID to create unique selector to avoid replacing other wishlist items
            var currentElement = wishlistContainer.querySelector(
              `[data-variant-id="${variant_id}"]`
            );
            if (currentElement) {
              currentElement.replaceWith(targetElement);
            } else {
              appendInOrderByIndex(targetElement, wishlistContainer);
            }

            const quantityInput = targetElement.querySelector("quantity-input");
            customElements.upgrade(quantityInput);
          } else {
            console.warn(
              "Likely a 404 => product variant not found. Removing product from favorites..."
            );
            // remove product from wishlist
            const url = window.digismoothieWishlistApp.appUrl;
            const data = {
              shop_url: window.Shopify.shop,
              customer_id: window.currentCustomerId,
              product_handle: handle,
              variant_id: variant_id,
              action: "remove",
            };

            fetch(url, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify(data),
            }).finally(() => {
              console.log("Removed");
            });
          }

          counter--;
          if (counter == 0) {
            initializeQuickOrderList(addDebounce);
            hideLoading();
            handleLoadMoreButton(showLoadMore, loadMoreStartIndex);

            reToggleLoading();
          }
        })
        .catch((error) => {
          console.error("Chyba při načítání produktu:", error);
          counter--; // Don't forget to decrement counter on error
          if (counter == 0) {
            initializeQuickOrderList(addDebounce);
            hideLoading();
            handleLoadMoreButton(showLoadMore, loadMoreStartIndex);

            reToggleLoading();
          }
        });
    }
  }
};

/*
document.addEventListener('DOMContentLoaded', () => {
  const loadMoreWishlistButton = document.getElementById('loadMoreWishlist');

  // Add an onClick event listener to the button
  loadMoreWishlistButton.addEventListener('click', function(e) {
      e.preventDefault();
      showLoading();
      renderWishlistItems(null, true, 50, Number(loadMoreWishlistButton.dataset.startIndex))
      return false;
  });

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
        if (entry.isIntersecting) {
            console.log('Element is in view!');
            loadMoreWishlistButton.click();
        }
    });
  }, { threshold: 0.75 }); // Trigger when 75% of the element is in view
  // Start observing the target element
  observer.observe(loadMoreWishlistButton);
});
*/

function setupPaginationControls(currentPage, itemsPerPage) {
  const paginationContainer = document.getElementById("paginationLinks");
  const totalItems = Object.entries(defaultWishlist).length;
  const totalPages = Math.ceil(totalItems / itemsPerPage);

  // Configure Prev/Next buttons
  const prevBtn = document.getElementById("prevPage");
  const nextBtn = document.getElementById("nextPage");
  prevBtn.href = `?page=${currentPage - 1}`;
  nextBtn.href = `?page=${currentPage + 1}`;
  prevBtn.style.display = currentPage > 1 ? "inline-flex" : "none";
  nextBtn.style.display = currentPage < totalPages ? "inline-flex" : "none";

  const quickOrderList = paginationContainer.closest("quick-order-list");

  // Generate numeric page links
  paginationContainer.innerHTML = "";

  function createLink(i, isActive = false) {
    const listitem = document.createElement("li");
    const link = document.createElement("a");
    link.textContent = i;
    link.className = "pagination__item link";
    link.ariaLabel = window.pageString.replace("{{ number }}", i);
    if (isActive) {
      link.classList.remove("link");
      link.role = "link";
      link.ariaDisabled = "true";
      link.ariaCurrent = "page";
      link.classList.add("pagination__item--current");
      link.classList.add("light");
    } else {
      link.href = i === 1 ? location.pathname : `?page=${i}`;
      link.addEventListener("click", function (e) {
        e.preventDefault();
        showLoading();
        quickOrderList.scrollIntoView();
        renderWishlistItems(
          null,
          true,
          itemsPerPage,
          (i - 1) * itemsPerPage,
          true
        );
        setupPaginationControls(i, itemsPerPage);
        let new_title = getPagePaginatedTitle(currentPage, i);
        if (i === 1) new_title = window.defaultPageTitle;
        document.title = new_title;
        history.pushState({ title: new_title }, "", link.href);
        return false;
      });
    }
    listitem.appendChild(link);
    return listitem;
  }

  function createEllipsis() {
    const listitem = document.createElement("li");
    const span = document.createElement("span");
    span.textContent = "...";
    span.className = "pagination__item";
    listitem.appendChild(span);
    return listitem;
  }

  paginationContainer.appendChild(prevBtn);
  const range = 2; // How many pages to show around currentPage
  for (let i = 1; i <= totalPages; i++) {
    if (
      i === 1 ||
      i === totalPages ||
      (i >= currentPage - range && i <= currentPage + range)
    ) {
      paginationContainer.appendChild(createLink(i, i === currentPage));
    } else if (
      (i === 2 && currentPage > range + 2) || // Insert ellipsis after page 1
      (i === totalPages - 1 && currentPage < totalPages - range - 1) // Insert before last page
    ) {
      paginationContainer.appendChild(createEllipsis());
    }
  }
  paginationContainer.appendChild(nextBtn);
}

function getPagePaginatedTitle(currentPage, targetPage) {
  let doc_title = document.title;
  let new_title = doc_title.replace(
    "Page " + currentPage,
    "Page " + targetPage
  );
  if (doc_title == new_title) {
    doc_title_parts = doc_title.split(/\s[–-]\s/);
    new_title =
      doc_title_parts[0] +
      " \u2013 " +
      "Page " +
      targetPage +
      " \u2013 " +
      doc_title_parts[1];
  }
  return new_title;
}

addEventListener("popstate", (e) => {
  const urlParams = new URLSearchParams(window.location.search);
  const page = parseInt(urlParams.get("page")) || 1;
  const startIndex = (page - 1) * paginationItemsPerPage;
  const title = e.state?.title || window.defaultPageTitle;
  showLoading();
  renderWishlistItems(null, true, paginationItemsPerPage, startIndex, true);
  setupPaginationControls(page, paginationItemsPerPage);
  document.title = title;
  return false;
});

// Funkce pro inicializaci `QuickOrderList` a `quantity-input`
function initializeQuickOrderList(addDebounce) {
  // Najdeme všechny `quick-order-list` prvky
  const quickOrderLists = document.querySelectorAll("quick-order-list");

  quickOrderLists.forEach((list) => {
    // Kontrola, zda již byl inicializován
    if (!list.dataset.initialized) {
      list.dataset.initialized = true;

      if (!customElements.get("quick-order-list")) {
        customElements.define("quick-order-list", QuickOrderList);
      } else {
        customElements.upgrade(list); // Ruční inicializace existujícího prvku
      }

      // Call a custom initialization method explicitly
      if (typeof list.customInit === "function") {
        list.customInit(); // Your custom method that uses the parameter
      }

      // Inicializace `quantity-input` prvků uvnitř `quick-order-list`
      //initializeQuantityInputs(list);
    }
    if (addDebounce) {
      // Call a custom initialization method explicitly
      if (typeof list.addMultipleDebounce === "function") {
        list.addMultipleDebounce();
      }
    }
  });
}

if (!customElements.get("quick-order-list-remove-button")) {
  customElements.define(
    "quick-order-list-remove-button",
    class QuickOrderListRemoveButton extends BulkAdd {
      constructor() {
        super();
        this.addEventListener("click", (event) => {
          event.preventDefault();
          this.startQueue(this.dataset.index, 0);
        });
      }
    }
  );
}

if (!customElements.get("quick-order-list-remove-all-button")) {
  customElements.define(
    "quick-order-list-remove-all-button",
    class QuickOrderListRemoveAllButton extends HTMLElement {
      constructor() {
        super();
        this.quickOrderList = this.closest("quick-order-list");
        const allVariants = this.quickOrderList.querySelectorAll(
          "[data-quantity-variant-id]"
        );
        const items = {};
        let hasVariantsInCart = false;

        allVariants.forEach((variant) => {
          const cartQty = parseInt(variant.dataset.cartQuantity);
          if (cartQty > 0) {
            hasVariantsInCart = true;
            items[parseInt(variant.dataset.quantityVariantId)] = 0;
          }
        });

        if (!hasVariantsInCart) {
          this.classList.add("hidden");
        }

        this.actions = {
          confirm: "confirm",
          remove: "remove",
          cancel: "cancel",
        };

        this.addEventListener("click", (event) => {
          event.preventDefault();
          if (this.dataset.action === this.actions.confirm) {
            this.toggleConfirmation(false, true);
          } else if (this.dataset.action === this.actions.remove) {
            this.quickOrderList.updateMultipleQty(items);
            this.toggleConfirmation(true, false);
          } else if (this.dataset.action === this.actions.cancel) {
            this.toggleConfirmation(true, false);
          }
        });
      }

      toggleConfirmation(showConfirmation, showInfo) {
        this.quickOrderList
          .querySelector(".quick-order-list-total__confirmation")
          .classList.toggle("hidden", showConfirmation);
        this.quickOrderList
          .querySelector(".quick-order-list-total__info")
          .classList.toggle("hidden", showInfo);
      }
    }
  );
}

if (!customElements.get("quick-order-list")) {
  customElements.define(
    "quick-order-list",
    class QuickOrderList extends BulkAdd {
      constructor() {
        super();

        this.cart = document.querySelector("cart-drawer");
        this.quickOrderListId = `${this.dataset.section}-${this.dataset.productId}`;
        this.defineInputsAndQuickOrderTable();

        this.variantItemStatusElement = document.getElementById(
          "shopping-cart-variant-item-status"
        );
        const form = this.querySelector("form");
        this.inputFieldHeight = this.querySelector(
          ".variant-item__quantity-wrapper"
        )?.offsetHeight;
        this.isListInsideModal = document.querySelector(".quick-add-bulk");
        this.stickyHeaderElement = document.querySelector("sticky-header");

        if (this.stickyHeaderElement) {
          this.stickyHeader = {
            height: this.stickyHeaderElement.offsetHeight,
            type: `${this.stickyHeaderElement.getAttribute(
              "data-sticky-type"
            )}`,
          };
        }

        const pageParams = new URLSearchParams(window.location.search);
        window.pageNumber = decodeURIComponent(pageParams.get("page") || "");
        form.addEventListener("submit", this.onSubmit.bind(this));
        this.addMultipleDebounce();
      }

      cartUpdateUnsubscriber = undefined;

      onSubmit(event) {
        event.preventDefault();
      }

      customInit() {
        this.cart = document.querySelector("cart-drawer");
        this.quickOrderListId = `${this.dataset.section}-${this.dataset.productId}`;
        this.defineInputsAndQuickOrderTable();

        this.variantItemStatusElement = document.getElementById(
          "shopping-cart-variant-item-status"
        );
        this.inputFieldHeight = this.querySelector(
          ".variant-item__quantity-wrapper"
        )?.offsetHeight;
        this.isListInsideModal = document.querySelector(".quick-add-bulk");
        this.stickyHeaderElement = document.querySelector("sticky-header");

        if (this.stickyHeaderElement) {
          this.stickyHeader = {
            height: this.stickyHeaderElement.offsetHeight,
            type: `${this.stickyHeaderElement.getAttribute(
              "data-sticky-type"
            )}`,
          };
        }

        const pageParams = new URLSearchParams(window.location.search);
        window.pageNumber = decodeURIComponent(pageParams.get("page") || "");
        this.addMultipleDebounce();
      }

      connectedCallback() {
        this.cartUpdateUnsubscriber = subscribe(
          PUB_SUB_EVENTS.cartUpdate,
          (event) => {
            const variantIds = [];
            this.querySelectorAll(".variant-item").forEach((item) => {
              variantIds.push(parseInt(item.dataset.variantId));
            });
            if (
              event.source === this.quickOrderListId ||
              !event.cartData.items?.some((element) =>
                variantIds.includes(element.variant_id)
              )
            ) {
              return;
            }
            // If its another section that made the update
            this.refresh().then(() => {
              this.defineInputsAndQuickOrderTable();
              this.addMultipleDebounce();
            });
          }
        );

        this.sectionId = this.dataset.section;
      }

      disconnectedCallback() {
        this.cartUpdateUnsubscriber?.();
      }

      defineInputsAndQuickOrderTable() {
        this.allInputsArray = Array.from(
          this.querySelectorAll('input[type="number"]')
        );
        this.quickOrderListTable = this.querySelector(
          ".quick-order-list__table"
        );
        this.quickOrderListTable.addEventListener(
          "focusin",
          this.switchVariants.bind(this)
        );
      }

      onChange(event) {
        const inputValue = parseInt(event.target.value);
        this.cleanErrorMessageOnType(event);
        if (inputValue == 0) {
          this.startQueue(event.target.dataset.index, inputValue);
        } else {
          this.validateQuantity(event);
        }
      }

      cleanErrorMessageOnType(event) {
        event.target.addEventListener("keydown", () => {
          event.target.setCustomValidity(" ");
          event.target.reportValidity();
        });
      }

      validateInput(target) {
        if (target.max) {
          return (
            parseInt(target.value) == 0 ||
            (parseInt(target.value) >= parseInt(target.dataset.min) &&
              parseInt(target.value) <= parseInt(target.max) &&
              parseInt(target.value) % parseInt(target.step) == 0)
          );
        } else {
          return (
            parseInt(target.value) == 0 ||
            (parseInt(target.value) >= parseInt(target.dataset.min) &&
              parseInt(target.value) % parseInt(target.step) == 0)
          );
        }
      }

      refresh() {
        return new Promise((resolve, reject) => {
          fetch(`${this.getSectionsUrl()}?section_id=${this.sectionId}`)
            .then((response) => response.text())
            .then((responseText) => {
              const html = new DOMParser().parseFromString(
                responseText,
                "text/html"
              );
              const sourceQty = html.querySelector(`#${this.quickOrderListId}`);
              if (sourceQty) {
                this.innerHTML = sourceQty.innerHTML;

                reToggleLoading();
              }
              resolve();
            })
            .catch((e) => {
              console.error(e);
              reject(e);
            });
        });
      }

      getSectionsToRender(ids) {
        return [
          /*{
            id: this.quickOrderListId,
            section: document.getElementById(this.quickOrderListId).dataset.section,
            selector: `#${this.quickOrderListId} .js-contents`,
          },*/
          {
            id: "cart-icon-bubble",
            section: "cart-icon-bubble",
            selector: ".shopify-section",
          },
          /*{
            id: `quick-order-list-live-region-text-${this.dataset.productId}`,
            section: 'cart-live-region-text',
            selector: '.shopify-section',
          },
          {
            id: `quick-order-list-total-${this.dataset.productId}-${this.dataset.section}`,
            section: document.getElementById(this.quickOrderListId).dataset.section,
            selector: `#${this.quickOrderListId} .quick-order-list__total`,
          },
          {
            id: 'CartDrawer',
            selector: '#CartDrawer',
            section: 'cart-drawer',
          },*/
        ];
      }

      addMultipleDebounce() {
        this.querySelectorAll("quantity-input").forEach((qty) => {
          const debouncedOnChange = debounce((event) => {
            this.onChange(event);
          }, 100);
          qty.addEventListener("input", debouncedOnChange.bind(this));
          qty.addEventListener("change", debouncedOnChange.bind(this));
        });
      }

      renderSections(parsedState, ids, displayStockWarning) {
        let anyElementsReplaced = false;

        this.getSectionsToRender(ids).forEach((section) => {
          const sectionElement = document.getElementById(section.id);
          if (
            sectionElement &&
            sectionElement.parentElement &&
            sectionElement.parentElement.classList.contains("drawer")
          ) {
            parsedState.items.length > 0
              ? sectionElement.parentElement.classList.remove("is-empty")
              : sectionElement.parentElement.classList.add("is-empty");
            setTimeout(() => {
              document
                .querySelector("#CartDrawer-Overlay")
                .addEventListener("click", this.cart.close.bind(this.cart));
            });
          }
          const elementToReplace =
            sectionElement && sectionElement.querySelector(section.selector)
              ? sectionElement.querySelector(section.selector)
              : sectionElement;
          if (elementToReplace) {
            elementToReplace.innerHTML = this.getSectionInnerHTML(
              parsedState.sections[section.section],
              section.selector
            );
            anyElementsReplaced = true;
          }
        });
        this.defineInputsAndQuickOrderTable();
        this.addMultipleDebounce();

        if (anyElementsReplaced) {
          reToggleLoading();
        }
      }

      switchVariants(event) {
        if (event.target.tagName !== "INPUT") {
          return;
        }

        this.variantListInput = event.target;
        this.variantListInput.select();
        if (this.allInputsArray.length !== 1) {
          this.variantListInput.addEventListener("keydown", (e) => {
            if (e.key === "Enter") {
              e.preventDefault();
              e.target.blur();
              if (this.validateInput(e.target)) {
                const currentIndex = this.allInputsArray.indexOf(e.target);
                this.lastKey = e.shiftKey;
                if (!e.shiftKey) {
                  const nextIndex = currentIndex + 1;
                  const nextVariant =
                    this.allInputsArray[nextIndex] || this.allInputsArray[0];
                  nextVariant.select();
                } else {
                  const previousIndex = currentIndex - 1;
                  const previousVariant =
                    this.allInputsArray[previousIndex] ||
                    this.allInputsArray[this.allInputsArray.length - 1];
                  this.lastElement = previousVariant.dataset.index;
                  previousVariant.select();
                }
              }
            }
          });
        } else {
          this.variantListInput.addEventListener("keydown", (e) => {
            if (e.key === "Enter") {
              e.preventDefault();
              e.target.blur();
            }
          });
        }
      }

      async mutateCart(
        items,
        sectionsToRender,
        displayStockWarning,
        rowsToReload,
        isFallback = false
      ) {
        const ids = Object.keys(items);

        const body = JSON.stringify({
          updates: items,
          sections: sectionsToRender,
          sections_url: this.dataset.url,
        });

        try {
          let quickOrderListWishlistInstances =
            document.querySelectorAll("quick-order-list");
          for (const instance of quickOrderListWishlistInstances) {
            // TODO: this should only be called on instances that actually changed
            instance.updateMessage();
            instance.setErrorMessage();
          }

          const response = await fetch(`${routes.cart_update_url}`, {
            ...fetchConfig(),
            ...{ body },
          });
          const state = await response.text();
          let parsedState = JSON.parse(state);

          const isBatchRequest = ids.length > 1;
          if (isFallback) {
            return parsedState;
          }
          if ("errors" in parsedState && isBatchRequest) {
            for (const itemEntry of Object.entries(items)) {
              // TODO: remove or significantly decrease this "delay" when Shopify boosts the AJAX cart API throttling limits
              // await new Promise((resolve) => setTimeout(resolve, 500));

              const fallbackItems = Object.fromEntries([itemEntry]);
              await this.mutateCart(
                fallbackItems,
                [],
                displayStockWarning,
                rowsToReload,
                true
              );
            }

            // TODO: remove or significantly decrease this "delay" when Shopify boosts the AJAX cart API throttling limits
            // await new Promise((resolve) => setTimeout(resolve, 500));

            parsedState = await this.mutateCart(
              {},
              sectionsToRender,
              displayStockWarning,
              rowsToReload,
              false
            );
          }

          this.renderSectionsGlobal(parsedState, ids, displayStockWarning);

          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: this.quickOrderListId,
            cartData: parsedState,
          });

          return parsedState;
        } catch (error) {
          console.error(error, { isFallback });
          let quickOrderListWishlistInstances =
            document.querySelectorAll("quick-order-list");
          for (const instance of quickOrderListWishlistInstances) {
            // TODO: this should only be called on instances that actually changed - or track errors per line ID
            instance.setErrorMessage(window.cartStrings.error);
          }
          return null;
        } finally {
          if (!isFallback) {
            let quickOrderListWishlistInstances =
              document.querySelectorAll("quick-order-list");
            for (const instance of quickOrderListWishlistInstances) {
              // instance.querySelector('.variant-remove-total .loading__spinner')?.classList.add('hidden');

              for (const itemId of ids) {
                const pending = BulkAdd.globalState.queue.some(
                  (queueItem) => queueItem.id === itemId
                );
                if (!pending) {
                  instance.toggleLoading(itemId, false);
                }
              }
            }
            this.requestStarted = false;
            BulkAdd.globalState.requestStarted = false;

            processingIds.length = 0;

            if (rowsToReload.length > 0) {
              renderWishlistItems(rowsToReload, true);
            } else {
              hideLoading();
            }
          }
        }
      }

      sendRequest(queue) {
        reToggleLoading();
        processingIds.length = 0;
        processingIds.push(...queue.map((item) => item.id));

        super.sendRequest(queue);
      }

      updateMultipleQty(items) {
        const removeAnyItems = Object.values(items).some(
          (quantity) => quantity <= 0
        );
        if (removeAnyItems) {
          showLoading();
        }

        // Check if the quantity of the variant is greater than the inventory quantity
        let displayStockWarning = false;
        const rowsToReload = [];

        Object.keys(items).forEach((variantId) => {
          const inputElement = document.querySelector(
            `[data-quantity-variant-id="${variantId}"]`
          );
          if (inputElement) {
            const inventoryQuantity = parseInt(
              inputElement.dataset.inventoryQuantity
            );
            if (!isNaN(inventoryQuantity)) {
              if (items[variantId] > inventoryQuantity) {
                items[variantId] = inventoryQuantity;
                displayStockWarning = true;
              }
            }
            rowsToReload.push({
              product_handle:
                inputElement.closest(".variant-item").dataset.handle,
              variant_id: variantId,
            });
          }
        });

        const quickOrderListWishlistInstances =
          document.querySelectorAll("quick-order-list");
        for (const instance of quickOrderListWishlistInstances) {
          // instance.querySelector('.variant-remove-total .loading__spinner')?.classList.remove('hidden');

          for (const itemId of Object.keys(items)) {
            instance.toggleLoading(itemId, true);
          }
        }

        const ids = Object.keys(items);
        const allSectionsToRender = this.getSectionsToRenderGlobal(ids);

        this.mutateCart(
          items,
          allSectionsToRender,
          displayStockWarning,
          rowsToReload
        ).catch((error) => console.error(error));
      }

      setErrorMessage(message = null) {
        this.errorMessageTemplate =
          this.errorMessageTemplate ??
          document
            .getElementById(
              `QuickOrderListErrorTemplate-${this.dataset.productId}`
            )
            .cloneNode(true);
        const errorElements = document.querySelectorAll(
          ".quick-order-list-error"
        );

        errorElements.forEach((errorElement) => {
          errorElement.innerHTML = "";
          if (!message) return;
          const updatedMessageElement =
            this.errorMessageTemplate.cloneNode(true);
          updatedMessageElement.content.querySelector(
            ".quick-order-list-error-message"
          ).innerText = message;
          errorElement.appendChild(updatedMessageElement.content);
        });
      }

      updateMessage(quantity = null) {
        const messages = this.querySelectorAll(
          ".quick-order-list__message-text"
        );
        const icons = this.querySelectorAll(".quick-order-list__message-icon");

        if (quantity === null || isNaN(quantity)) {
          messages.forEach((message) => (message.innerHTML = ""));
          icons.forEach((icon) => icon.classList.add("hidden"));
          return;
        }

        const isQuantityNegative = quantity < 0;
        const absQuantity = Math.abs(quantity);

        const textTemplate = isQuantityNegative
          ? absQuantity === 1
            ? window.quickOrderListStrings.itemRemoved
            : window.quickOrderListStrings.itemsRemoved
          : quantity === 1
          ? window.quickOrderListStrings.itemAdded
          : window.quickOrderListStrings.itemsAdded;

        messages.forEach(
          (msg) =>
            (msg.innerHTML = textTemplate.replace("[quantity]", absQuantity))
        );

        if (!isQuantityNegative) {
          icons.forEach((i) => i.classList.remove("hidden"));
        }
      }

      updateError(updatedValue, id) {
        let message = "";
        if (typeof updatedValue === "undefined") {
          message = window.cartStrings.error;
        } else {
          message = window.cartStrings.quantityError.replace(
            "[quantity]",
            updatedValue
          );
        }
        this.updateLiveRegions(id, message);
      }

      cleanErrors(id) {
        // this.querySelectorAll('.desktop-row-error').forEach((error) => error.classList.add('hidden'));
        // this.querySelectorAll(`.variant-item__error-text`).forEach((error) => error.innerHTML = '');
      }

      updateLiveRegions(id, message) {
        const variantItemErrorDesktop = document.getElementById(
          `Quick-order-list-item-error-desktop-${id}`
        );
        const variantItemErrorMobile = document.getElementById(
          `Quick-order-list-item-error-mobile-${id}`
        );
        if (variantItemErrorDesktop) {
          variantItemErrorDesktop.querySelector(
            ".variant-item__error-text"
          ).innerHTML = message;
          variantItemErrorDesktop.closest("tr").classList.remove("hidden");
        }
        if (variantItemErrorMobile)
          variantItemErrorMobile.querySelector(
            ".variant-item__error-text"
          ).innerHTML = message;

        this.variantItemStatusElement.setAttribute("aria-hidden", true);

        const cartStatus = document.getElementById(
          "quick-order-list-live-region-text"
        );
        cartStatus.setAttribute("aria-hidden", false);

        setTimeout(() => {
          cartStatus.setAttribute("aria-hidden", true);
        }, 1000);
      }

      toggleLoading(id, enable) {
        const quickOrderListItems = this.querySelectorAll(
          `#Variant-${id} .loading__spinner`
        );
        // const quickOrderListItem = this.querySelector(`#Variant-${id}`);

        if (enable) {
          // quickOrderListItem.classList.add('quick-order-list__container--disabled');
          quickOrderListItems.forEach((overlay) =>
            overlay.classList.remove("hidden")
          );
          this.variantItemStatusElement.setAttribute("aria-hidden", false);
        } else {
          // quickOrderListItem.classList.remove('quick-order-list__container--disabled');
          quickOrderListItems.forEach((overlay) =>
            overlay.classList.add("hidden")
          );
        }
      }
    }
  );
}
